export const validate = () => {
  const errors = {}
  return errors
}

export const required = value => (value ? undefined : 'Required')

export const noEmptySpaces = value => value && value.trimStart()
